const formLabelModalSupportFiles = {
  label: 'Visibilidade'
};

export default formLabelModalSupportFiles;
